import { gql } from '@apollo/client';

export const READ_CHARGING_RECEIPT_PDF = gql`
  query readChargingSessionPdf($sessionId: ID!) {
    readChargingSessionPdf(sessionId: $sessionId) {
      chargingSessionId
      base64PdfFile
    }
  }
`;
